import type { PaymentAmount } from '@adyen/adyen-web'

export function getAdyenPaymentAmount({
  priceTotal,
  currency,
}: {
  priceTotal: number
  currency: string
}): PaymentAmount {
  return {
    value: priceTotal,
    currency,
  }
}
